
const DirecitveEntryExecutionEntryCompleted = () => {
  return (
    <p className="text-valid">
      Concluído
    </p>
  );
}

export default DirecitveEntryExecutionEntryCompleted;
